export const RESET_REPORTS_VIEW = "RESET_REPORTS_VIEW";
export const RESET_ALL_REPORTS = "RESET_ALL_REPORTS";
export const SET_SELECTED_REPORT = "SET_SELECTED_REPORT";
export const SET_MANAGEMENT_SELECTED_REPORT = "SET_MANAGEMENT_SELECTED_REPORT";
export const GET_ALL_REPORTS_REQUEST = "GET_ALL_REPORTS_REQUEST";
export const GET_ALL_REPORTS_SUCCESS = "GET_ALL_REPORTS_SUCCESS";
export const GET_ALL_REPORTS_FAILURE = "GET_ALL_REPORTS_FAILURE";
export const UPDATE_REPORT_SEARCH_KEY = "UPDATE_REPORT_SEARCH_KEY";
